module.exports = __webpack_public_path__ + "img/有害生物防治大数据平台.0b1b6450.png";